import * as yup from 'yup';

export const schemaSignatureUsc = yup.object().shape({
  user: yup.string().nullable().required('Campo obbligatorio'),
  pin: yup.string().nullable().required('Campo obbligatorio'),
  // otp: yup.string().nullable().required('Campo obbligatorio'),
  isAnagrafica: yup.boolean().nullable(),
  dateValidity: yup
    .date()
    .typeError('Data non valida')
    .nullable()
    .when('isAnagrafica', {
      is: (isAnagrafica: boolean) => isAnagrafica,
      then: yup.date().typeError('Data non valida').nullable().required('Campo obbligatorio'),
      otherwise: yup.date().typeError('Data non valida').nullable(),
    }),
});
